/*
 * Copyright (c) 2020 SQUAREPING INC.
 *
 * SQUAREPING CONFIDENTIAL
 * [2019 and Beyond] SQUAREPING INC. All Rights Reserved.
 *
 * NOTICE: The source code contained herein is, and remains the property of SQUAREPING INC.
 * and its suppliers, if any. The intellectual and technical concepts contained herein are
 * proprietary to SQUAREPING INC. and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material is strictly forbidden
 * anywhere in the world unless prior written permission is obtained from SQUAREPING INC.
 */

import * as mitt from 'mitt';

export default class Emitter {
  private static emitter: mitt.Emitter<any> = mitt.default();

  static emit(event: string, data: unknown): void {
    this.emitter.emit(event, data);
  }

  static on(event: string, handler: mitt.Handler): void {
    this.emitter.on(event, handler);
  }

  static off(event: string, handler: mitt.Handler): void {
    this.emitter.off(event, handler);
  }
}
